// Aurevia Travella — single source of truth for destinations.
// To add a new country: add an entry under a continent. To add a city: add to its country.
const IMG = (id, w = 1600) =>
  `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=80`;

export const PHOTOS = {
  paris: IMG("1502602898657-3e91760cbb34"),
  provence: IMG("1499002238440-d264edd596ec"),
  rome: IMG("1552832230-c0197dd311b5"),
  venice: IMG("1523906834658-6e24ef2386f9"),
  positano: IMG("1516483638261-f4dbaf036963"),
  barcelona: IMG("1583422409516-2895a77efded"),
  madrid: IMG("1539037116277-4db20889f2d4"),
  london: IMG("1513635269975-59663e0ac1ad"),
  nyc: IMG("1496442226666-8d4d0e62e6e9"),
  la: IMG("1444723121867-7a241cacace9"),
  miami: IMG("1506966953602-c20cc11f75e3"),
  toronto: IMG("1517090504586-fde19ea6066f"),
  rockies: IMG("1464822759023-fed622ff2c3b"),
  vancouver: IMG("1559511260-66a654ae982a"),
  dubai: IMG("1512453979798-5ea266f8880c"),
  abudhabi: IMG("1512632578888-169bbbc64f33"),
  riyadh: IMG("1586724237569-f3d0c1dee8c6"),
  cairo: IMG("1503177119275-0aa32b3a9368"),
  bangkok: IMG("1508009603885-50cf7c579365"),
  phiphi: IMG("1552465011-b4e21bf6e79a"),
  tokyo: IMG("1540959733332-eab4deabeeaf"),
  kyoto: IMG("1493976040374-85c8e12f0c0e"),
  seoul: IMG("1538485399081-7191377e8241"),
  singapore: IMG("1525625293386-3f8f99389edd"),
  sydney: IMG("1506973035872-a4ec16b8e8d9"),
  melbourne: IMG("1514395462725-fb4566210144"),
  maldives: IMG("1514282401047-d79a71a590e8"),
  seychelles: IMG("1544550581-5f7ceaf7f992"),
  beach: IMG("1507525428034-b723cf961d3e"),
  bali: IMG("1537996194471-e657df975ab4"),
  puntacana: IMG("1510414842594-a61c69b5ae57"),
  milan: IMG("1510172951991-856a654063f9"),
  florence: IMG("1541370976299-4d24ebbc9077"),
  osaka: IMG("1590559899731-a382839e5549"),
  jet: IMG("1540962351504-03099e0a754b"),
  hotel: IMG("1566073771259-6a8506099945"),
  car: IMG("1503376780353-7e6692767b70"),
  planewing: IMG("1436491865332-7a61a109cc05"),
  medical: IMG("1576091160399-112ba8d25d1d"),
  family: IMG("1511895426328-dc8714191300"),
  business: IMG("1507679799987-c73779587ccf"),
  traveler: IMG("1488646953014-85cb44e25828"),
  yacht: IMG("1540946485063-a40da27545f8"),
  desert: IMG("1473580044384-7ba9967e16a0"),
  istanbul: IMG("1524231757912-21f4fe3a7200"),
  bluemosque: IMG("1541432901042-2d8bd64b4a9b"),
  cappadocia: IMG("1695415683093-ae5f213ea898"),
  athens: IMG("1555993539-1732b0258235"),
  santorini: IMG("1613395877344-13d4a8e0d49e"),
  lisbon: IMG("1555881400-74d7acaacd8b"),
  porto: IMG("1513735492246-483525079686"),
  amsterdam: IMG("1534351590666-13e3e96b5017"),
  zurich: IMG("1515488764276-beab7607c1e6"),
  berlin: IMG("1560969184-10fe8719e047"),
  mexicocity: IMG("1518105779142-d975f22f1b0a"),
  cancun: IMG("1510097467424-192d713fd8b2"),
  delhi: IMG("1587474260584-136574528ed5"),
  mumbai: IMG("1570168007204-dfb528c6958f"),
  beijing: IMG("1508804185872-d7badad00f7d"),
  shanghai: IMG("1548919973-5cef591cdbc9"),
  auckland: IMG("1507699622108-4be3abd695ad"),
  queenstown: IMG("1469521669194-babb45599def"),
  fiji: IMG("1582555172866-f73bb12a2ab3"),
  borabora: IMG("1589197331516-4d84b72ebde3"),
  concierge: IMG("1766066014237-00645c74e9c6"),
  skyline: IMG("1786991779793-676053edf837"),
};

export const CONTINENTS = [
  {
    id: "europe",
    region: { n: 71, s: 35, w: -11, e: 45 },
    countries: [
      {
        slug: "france", name: "France", lat: 46.6, lon: 2.5, img: PHOTOS.paris,
        gallery: [PHOTOS.paris, PHOTOS.provence],
        cities: [
          { slug: "paris", name: "Paris", lat: 48.8566, lon: 2.3522, airport: "CDG", img: PHOTOS.paris },
          { slug: "nice", name: "Nice", lat: 43.7102, lon: 7.262, airport: "NCE", img: PHOTOS.provence },
          { slug: "lyon", name: "Lyon", lat: 45.764, lon: 4.8357, airport: "LYS", img: PHOTOS.paris },
          { slug: "bordeaux", name: "Bordeaux", lat: 44.8378, lon: -0.5792, airport: "BOD", img: PHOTOS.provence },
        ],
      },
      {
        slug: "italy", name: "Italy", lat: 42.8, lon: 12.8, img: PHOTOS.rome,
        gallery: [PHOTOS.rome, PHOTOS.venice, PHOTOS.positano],
        cities: [
          { slug: "rome", name: "Rome", lat: 41.9028, lon: 12.4964, airport: "FCO", img: PHOTOS.rome },
          { slug: "milan", name: "Milan", lat: 45.4642, lon: 9.19, airport: "MXP", img: PHOTOS.milan },
          { slug: "venice", name: "Venice", lat: 45.4408, lon: 12.3155, airport: "VCE", img: PHOTOS.venice },
          { slug: "florence", name: "Florence", lat: 43.7696, lon: 11.2558, airport: "FLR", img: PHOTOS.florence },
        ],
      },
      {
        slug: "spain", name: "Spain", lat: 40.2, lon: -3.7, img: PHOTOS.barcelona,
        gallery: [PHOTOS.barcelona, PHOTOS.madrid],
        cities: [
          { slug: "madrid", name: "Madrid", lat: 40.4168, lon: -3.7038, airport: "MAD", img: PHOTOS.madrid },
          { slug: "barcelona", name: "Barcelona", lat: 41.3874, lon: 2.1686, airport: "BCN", img: PHOTOS.barcelona },
          { slug: "sevilla", name: "Sevilla", lat: 37.3891, lon: -5.9845, airport: "SVQ", img: PHOTOS.madrid },
          { slug: "valencia", name: "Valencia", lat: 39.4699, lon: -0.3763, airport: "VLC", img: PHOTOS.barcelona },
        ],
      },
      {
        slug: "united-kingdom", name: "United Kingdom", lat: 53.5, lon: -1.5, img: PHOTOS.london,
        gallery: [PHOTOS.london],
        cities: [
          { slug: "london", name: "London", lat: 51.5074, lon: -0.1278, airport: "LHR", img: PHOTOS.london },
          { slug: "manchester", name: "Manchester", lat: 53.4808, lon: -2.2426, airport: "MAN", img: PHOTOS.london },
          { slug: "edinburgh", name: "Edinburgh", lat: 55.9533, lon: -3.1883, airport: "EDI", img: PHOTOS.london },
        ],
      },
      {
        slug: "turkiye", name: "Türkiye", aliases: ["turkey"], lat: 38.9, lon: 35.2, img: PHOTOS.istanbul,
        gallery: [PHOTOS.istanbul, PHOTOS.bluemosque, PHOTOS.cappadocia],
        cities: [
          { slug: "istanbul", name: "İstanbul", aliases: ["istanbul", "constantinople"], lat: 41.0082, lon: 28.9784, airport: "IST", img: PHOTOS.istanbul },
          { slug: "antalya", name: "Antalya", lat: 36.8841, lon: 30.7056, airport: "AYT", img: PHOTOS.beach },
          { slug: "cappadocia", name: "Cappadocia", aliases: ["kapadokya"], lat: 38.6431, lon: 34.8289, airport: "NAV", img: PHOTOS.cappadocia },
        ],
      },
      {
        slug: "greece", name: "Greece", lat: 39.0, lon: 22.0, img: PHOTOS.santorini,
        gallery: [PHOTOS.santorini, PHOTOS.athens],
        cities: [
          { slug: "athens", name: "Athens", lat: 37.9838, lon: 23.7275, airport: "ATH", img: PHOTOS.athens },
          { slug: "santorini", name: "Santorini", lat: 36.3932, lon: 25.4615, airport: "JTR", img: PHOTOS.santorini },
        ],
      },
      {
        slug: "portugal", name: "Portugal", lat: 39.4, lon: -8.2, img: PHOTOS.lisbon,
        gallery: [PHOTOS.lisbon, PHOTOS.porto],
        cities: [
          { slug: "lisbon", name: "Lisbon", lat: 38.7223, lon: -9.1393, airport: "LIS", img: PHOTOS.lisbon },
          { slug: "porto", name: "Porto", lat: 41.1579, lon: -8.6291, airport: "OPO", img: PHOTOS.porto },
        ],
      },
      {
        slug: "netherlands", name: "Netherlands", lat: 52.2, lon: 5.3, img: PHOTOS.amsterdam,
        gallery: [PHOTOS.amsterdam],
        cities: [
          { slug: "amsterdam", name: "Amsterdam", lat: 52.3676, lon: 4.9041, airport: "AMS", img: PHOTOS.amsterdam },
        ],
      },
      {
        slug: "switzerland", name: "Switzerland", lat: 46.8, lon: 8.2, img: PHOTOS.zurich,
        gallery: [PHOTOS.zurich],
        cities: [
          { slug: "zurich", name: "Zurich", lat: 47.3769, lon: 8.5417, airport: "ZRH", img: PHOTOS.zurich },
          { slug: "geneva", name: "Geneva", lat: 46.2044, lon: 6.1432, airport: "GVA", img: PHOTOS.zurich },
        ],
      },
      {
        slug: "germany", name: "Germany", lat: 51.1, lon: 10.4, img: PHOTOS.berlin,
        gallery: [PHOTOS.berlin],
        cities: [
          { slug: "berlin", name: "Berlin", lat: 52.52, lon: 13.405, airport: "BER", img: PHOTOS.berlin },
          { slug: "munich", name: "Munich", lat: 48.1351, lon: 11.582, airport: "MUC", img: PHOTOS.berlin },
        ],
      },
    ],
  },
  {
    id: "north-america",
    region: { n: 72, s: 8, w: -168, e: -52 },
    countries: [
      {
        slug: "united-states", name: "United States", lat: 39.8, lon: -98.5, img: PHOTOS.nyc,
        gallery: [PHOTOS.nyc, PHOTOS.la, PHOTOS.miami],
        cities: [
          { slug: "new-york", name: "New York", lat: 40.7128, lon: -74.006, airport: "JFK", img: PHOTOS.nyc },
          { slug: "los-angeles", name: "Los Angeles", lat: 34.0522, lon: -118.2437, airport: "LAX", img: PHOTOS.la },
          { slug: "miami", name: "Miami", lat: 25.7617, lon: -80.1918, airport: "MIA", img: PHOTOS.miami },
        ],
      },
      {
        slug: "canada", name: "Canada", lat: 56.1, lon: -106.3, img: PHOTOS.toronto,
        gallery: [PHOTOS.toronto, PHOTOS.rockies, PHOTOS.vancouver],
        cities: [
          { slug: "toronto", name: "Toronto", lat: 43.6532, lon: -79.3832, airport: "YYZ", img: PHOTOS.toronto },
          { slug: "vancouver", name: "Vancouver", lat: 49.2827, lon: -123.1207, airport: "YVR", img: PHOTOS.vancouver },
          { slug: "montreal", name: "Montreal", lat: 45.5019, lon: -73.5674, airport: "YUL", img: PHOTOS.toronto },
        ],
      },
      {
        slug: "mexico", name: "Mexico", lat: 23.6, lon: -102.5, img: PHOTOS.mexicocity,
        gallery: [PHOTOS.mexicocity, PHOTOS.cancun],
        cities: [
          { slug: "mexico-city", name: "Mexico City", lat: 19.4326, lon: -99.1332, airport: "MEX", img: PHOTOS.mexicocity },
          { slug: "cancun", name: "Cancún", lat: 21.1619, lon: -86.8515, airport: "CUN", img: PHOTOS.cancun },
        ],
      },
    ],
  },
  {
    id: "middle-east",
    region: { n: 42, s: 12, w: 25, e: 64 },
    countries: [
      {
        slug: "united-arab-emirates", name: "United Arab Emirates", lat: 24.3, lon: 54.5, img: PHOTOS.dubai,
        gallery: [PHOTOS.dubai, PHOTOS.abudhabi],
        cities: [
          { slug: "dubai", name: "Dubai", lat: 25.2048, lon: 55.2708, airport: "DXB", img: PHOTOS.dubai },
          { slug: "abu-dhabi", name: "Abu Dhabi", lat: 24.4539, lon: 54.3773, airport: "AUH", img: PHOTOS.abudhabi },
        ],
      },
      {
        slug: "saudi-arabia", name: "Saudi Arabia", lat: 24.0, lon: 45.0, img: PHOTOS.riyadh,
        gallery: [PHOTOS.riyadh, PHOTOS.desert],
        cities: [
          { slug: "riyadh", name: "Riyadh", lat: 24.7136, lon: 46.6753, airport: "RUH", img: PHOTOS.riyadh },
        ],
      },
      {
        slug: "egypt", name: "Egypt", lat: 26.8, lon: 30.8, img: PHOTOS.cairo,
        gallery: [PHOTOS.cairo],
        cities: [
          { slug: "cairo", name: "Cairo", lat: 30.0444, lon: 31.2357, airport: "CAI", img: PHOTOS.cairo },
        ],
      },
      {
        slug: "qatar", name: "Qatar", lat: 25.3, lon: 51.2, img: PHOTOS.desert,
        gallery: [PHOTOS.desert, PHOTOS.abudhabi],
        cities: [
          { slug: "doha", name: "Doha", lat: 25.2854, lon: 51.531, airport: "DOH", img: PHOTOS.desert },
        ],
      },
    ],
  },
  {
    id: "asia",
    region: { n: 77, s: -9.5, w: 64, e: 150 },
    countries: [
      {
        slug: "thailand", name: "Thailand", lat: 15.8, lon: 101.0, img: PHOTOS.bangkok,
        gallery: [PHOTOS.bangkok, PHOTOS.phiphi],
        cities: [
          { slug: "bangkok", name: "Bangkok", lat: 13.7563, lon: 100.5018, airport: "BKK", img: PHOTOS.bangkok },
          { slug: "phuket", name: "Phuket", lat: 7.8804, lon: 98.3923, airport: "HKT", img: PHOTOS.phiphi },
        ],
      },
      {
        slug: "japan", name: "Japan", lat: 36.2, lon: 138.3, img: PHOTOS.tokyo,
        gallery: [PHOTOS.tokyo, PHOTOS.kyoto, PHOTOS.osaka],
        cities: [
          { slug: "tokyo", name: "Tokyo", lat: 35.6762, lon: 139.6503, airport: "HND", img: PHOTOS.tokyo },
          { slug: "osaka", name: "Osaka", lat: 34.6937, lon: 135.5023, airport: "KIX", img: PHOTOS.osaka },
        ],
      },
      {
        slug: "south-korea", name: "South Korea", lat: 36.5, lon: 127.9, img: PHOTOS.seoul,
        gallery: [PHOTOS.seoul],
        cities: [
          { slug: "seoul", name: "Seoul", lat: 37.5665, lon: 126.978, airport: "ICN", img: PHOTOS.seoul },
        ],
      },
      {
        slug: "singapore", name: "Singapore", lat: 1.3521, lon: 103.8198, img: PHOTOS.singapore,
        gallery: [PHOTOS.singapore],
        cities: [
          { slug: "singapore", name: "Singapore", lat: 1.3521, lon: 103.8198, airport: "SIN", img: PHOTOS.singapore },
        ],
      },
      {
        slug: "india", name: "India", lat: 21.0, lon: 78.0, img: PHOTOS.delhi,
        gallery: [PHOTOS.delhi, PHOTOS.mumbai],
        cities: [
          { slug: "new-delhi", name: "New Delhi", lat: 28.6139, lon: 77.209, airport: "DEL", img: PHOTOS.delhi },
          { slug: "mumbai", name: "Mumbai", lat: 19.076, lon: 72.8777, airport: "BOM", img: PHOTOS.mumbai },
        ],
      },
      {
        slug: "china", name: "China", lat: 35.0, lon: 105.0, img: PHOTOS.beijing,
        gallery: [PHOTOS.beijing, PHOTOS.shanghai],
        cities: [
          { slug: "beijing", name: "Beijing", lat: 39.9042, lon: 116.4074, airport: "PEK", img: PHOTOS.beijing },
          { slug: "shanghai", name: "Shanghai", lat: 31.2304, lon: 121.4737, airport: "PVG", img: PHOTOS.shanghai },
        ],
      },
    ],
  },
  {
    id: "oceania",
    region: { n: -10, s: -50, w: 112, e: 180 },
    countries: [
      {
        slug: "australia", name: "Australia", lat: -25.3, lon: 133.8, img: PHOTOS.sydney,
        gallery: [PHOTOS.sydney, PHOTOS.melbourne],
        cities: [
          { slug: "sydney", name: "Sydney", lat: -33.8688, lon: 151.2093, airport: "SYD", img: PHOTOS.sydney },
          { slug: "melbourne", name: "Melbourne", lat: -37.8136, lon: 144.9631, airport: "MEL", img: PHOTOS.melbourne },
        ],
      },
      {
        slug: "new-zealand", name: "New Zealand", lat: -41.5, lon: 172.8, img: PHOTOS.queenstown,
        gallery: [PHOTOS.queenstown, PHOTOS.auckland],
        cities: [
          { slug: "auckland", name: "Auckland", lat: -36.8485, lon: 174.7633, airport: "AKL", img: PHOTOS.auckland },
          { slug: "queenstown", name: "Queenstown", lat: -45.0312, lon: 168.6626, airport: "ZQN", img: PHOTOS.queenstown },
        ],
      },
    ],
  },
  {
    id: "islands",
    region: null,
    countries: [
      {
        slug: "maldives", name: "Maldives", lat: 3.2, lon: 73.2, img: PHOTOS.maldives,
        gallery: [PHOTOS.maldives, PHOTOS.beach],
        cities: [
          { slug: "male", name: "Malé", lat: 4.1755, lon: 73.5093, airport: "MLE", img: PHOTOS.maldives },
        ],
      },
      {
        slug: "seychelles", name: "Seychelles", lat: -4.6, lon: 55.5, img: PHOTOS.seychelles,
        gallery: [PHOTOS.seychelles, PHOTOS.beach],
        cities: [
          { slug: "mahe", name: "Mahé", lat: -4.6191, lon: 55.4513, airport: "SEZ", img: PHOTOS.seychelles },
        ],
      },
      {
        slug: "indonesia", name: "Indonesia", lat: -2.5, lon: 118.0, img: PHOTOS.bali,
        gallery: [PHOTOS.bali],
        cities: [
          { slug: "bali", name: "Bali", lat: -8.6500, lon: 115.2167, airport: "DPS", img: PHOTOS.bali },
        ],
      },
      {
        slug: "dominican-republic", name: "Dominican Republic", lat: 18.7, lon: -70.2, img: PHOTOS.puntacana,
        gallery: [PHOTOS.puntacana, PHOTOS.beach],
        cities: [
          { slug: "punta-cana", name: "Punta Cana", lat: 18.582, lon: -68.4055, airport: "PUJ", img: PHOTOS.puntacana },
        ],
      },
      {
        slug: "mauritius", name: "Mauritius", lat: -20.16, lon: 57.5, img: PHOTOS.beach,
        gallery: [PHOTOS.beach, PHOTOS.seychelles],
        cities: [
          { slug: "port-louis", name: "Port Louis", lat: -20.1609, lon: 57.5012, airport: "MRU", img: PHOTOS.beach },
        ],
      },
      {
        slug: "fiji", name: "Fiji", lat: -17.71, lon: 178.06, img: PHOTOS.fiji,
        gallery: [PHOTOS.fiji, PHOTOS.beach],
        cities: [
          { slug: "nadi", name: "Nadi", lat: -17.7765, lon: 177.4356, airport: "NAN", img: PHOTOS.fiji },
        ],
      },
      {
        slug: "french-polynesia", name: "French Polynesia", lat: -16.5, lon: -151.7, img: PHOTOS.borabora,
        gallery: [PHOTOS.borabora, PHOTOS.beach],
        cities: [
          { slug: "bora-bora", name: "Bora Bora", lat: -16.5004, lon: -151.7415, airport: "BOB", img: PHOTOS.borabora },
        ],
      },
    ],
  },
];

export const SERVICES = [
  { id: "hotels", icon: "Building2", img: PHOTOS.hotel },
  { id: "transfers", icon: "Plane", img: PHOTOS.planewing },
  { id: "vip", icon: "Crown", img: PHOTOS.jet },
  { id: "chauffeur", icon: "CarFront", img: PHOTOS.car },
  { id: "guides", icon: "Compass" },
  { id: "tours", icon: "Route" },
  { id: "family", icon: "Users", img: PHOTOS.family },
  { id: "business", icon: "Briefcase", img: PHOTOS.business },
  { id: "medical", icon: "HeartPulse", img: PHOTOS.medical },
];

export const HUBS = [
  { lat: 40.7128, lon: -74.006 }, { lat: 51.5074, lon: -0.1278 },
  { lat: 48.8566, lon: 2.3522 }, { lat: 25.2048, lon: 55.2708 },
  { lat: 1.3521, lon: 103.8198 }, { lat: -33.8688, lon: 151.2093 },
  { lat: 35.6762, lon: 139.6503 }, { lat: 34.0522, lon: -118.2437 },
  { lat: 30.0444, lon: 31.2357 }, { lat: 13.7563, lon: 100.5018 },
];

export const ARCS = [[0, 1], [1, 2], [1, 3], [3, 4], [4, 5], [7, 6], [6, 4], [2, 8], [8, 3], [4, 9]];

export const ALL_COUNTRIES = CONTINENTS.flatMap((c) =>
  c.countries.map((co) => ({ ...co, continent: c.id }))
);

export const ALL_CITIES = ALL_COUNTRIES.flatMap((co) =>
  co.cities.map((ci) => ({
    ...ci,
    countrySlug: co.slug,
    countryName: co.name,
    countryAliases: co.aliases || [],
    continent: co.continent,
  }))
);

export const getCountry = (slug) => ALL_COUNTRIES.find((c) => c.slug === slug);
export const getCity = (countrySlug, citySlug) =>
  ALL_CITIES.find((c) => c.countrySlug === countrySlug && c.slug === citySlug);
export const getContinent = (id) => CONTINENTS.find((c) => c.id === id);

export const SEARCH_INDEX = [
  ...ALL_COUNTRIES.map((c) => ({
    type: "country", label: c.name, sub: c.continent, path: `/destinations/${c.slug}`,
    keywords: `${c.name} ${(c.aliases || []).join(" ")}`.toLowerCase(),
  })),
  ...ALL_CITIES.flatMap((c) => [
    {
      type: "city", label: c.name, sub: c.countryName,
      path: `/destinations/${c.countrySlug}/${c.slug}`,
      keywords: `${c.name} ${c.countryName} ${(c.aliases || []).join(" ")} ${c.countryAliases.join(" ")}`.toLowerCase(),
    },
    ...(c.airport
      ? [{
          type: "airport", label: c.airport, sub: `${c.name}, ${c.countryName}`,
          path: `/destinations/${c.countrySlug}/${c.slug}`,
          keywords: `${c.airport} ${c.name} airport`.toLowerCase(),
        }]
      : []),
  ]),
];

export const MARQUEE_ITEMS = [
  "Paris", "Dubai", "Tokyo", "İstanbul", "New York", "Malé", "London", "Singapore",
  "Sydney", "Rome", "Bali", "Santorini", "Barcelona", "Seoul", "Cairo", "Bora Bora", "Lisbon", "Vancouver",
];
